import { c as _c } from "react/compiler-runtime";
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEFAULT_PUBLIC_ROUTE } from '@/config/constants';
import type { LoggedOutStorageState, Session } from './use-logged-out-storage.types';
import { defaultSession } from './use-logged-out-storage.types';
export const useStore = create<LoggedOutStorageState>()(persist(set => ({
  data: defaultSession,
  reset: () => set({
    data: defaultSession
  }),
  update: (data: Partial<Session>) => {
    set(oldSession => ({
      ...oldSession,
      data: {
        ...oldSession.data,
        ...data
      }
    }));
  }
}), {
  version: 1,
  name: 'logged-out-storage'
}));
const useLoggedOutStorage = () => {
  const $ = _c(5);
  const {
    data,
    reset,
    update
  } = useStore(_temp);
  const onLoginUrl = data.redirectUrl ? decodeURIComponent(data.redirectUrl) : DEFAULT_PUBLIC_ROUTE;
  let t0;
  if ($[0] !== data || $[1] !== onLoginUrl || $[2] !== reset || $[3] !== update) {
    t0 = {
      data,
      reset,
      update,
      onLoginUrl
    };
    $[0] = data;
    $[1] = onLoginUrl;
    $[2] = reset;
    $[3] = update;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
export default useLoggedOutStorage;
function _temp(state) {
  return state;
}